import { render, staticRenderFns } from "./GroupListTalksPage.vue?vue&type=template&id=327b07e1&scoped=true&"
import script from "./GroupListTalksPage.vue?vue&type=script&lang=js&"
export * from "./GroupListTalksPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "327b07e1",
  null
  
)

export default component.exports